import type { ComponentProps } from 'react';

export type CloudConsoleIconProps = ComponentProps<'svg'> & {
  title?: string;
};

// Same 24px grid and stroke as the Heroicons outline set, so it swaps in for
// ArrowTopRightOnSquareIcon at any size
export function CloudConsoleIcon({ title, ...props }: CloudConsoleIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      data-slot="icon"
      {...props}
    >
      {title ? <title>{title}</title> : null}
      <path d="M13 6.6C10 4.2 6 6.3 6 10.2V11.2H4.8A4.5 4.5 0 0 0 6.75 19.75H17.5A4.25 4.25 0 0 0 20.5 12.5 M10.5 13.5 21 3 M15.75 3H21v5.25" />
    </svg>
  );
}
